// Ô nhập dùng chung cho tab Cấu hình: nhãn đời thường + đơn vị + dòng giải thích + ví dụ.
import { Button, Card, InputNumber, Popconfirm, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Một ô: nhãn đậm, ô nhập, dòng giải thích nhỏ; `example` hiện khi rê chuột vào nhãn. */
export function Field({ label, hint, example, children, className = "mb-3" }) {
    const title = <span className="font-medium">{label}</span>;
    return (
        <div className={className}>
            <div className="mb-1">
                {example ? (
                    <Tooltip title={`Ví dụ: ${example}`}>
                        {title} <span className="text-blue-500 text-xs cursor-help">(xem ví dụ)</span>
                    </Tooltip>
                ) : (
                    title
                )}
            </div>
            {children}
            {hint && <div className="text-gray-500 text-xs mt-1 max-w-sm">{hint}</div>}
        </div>
    );
}

/** Ô số có đơn vị, rộng vừa đủ (không kéo full). `emptyMeans`: giá trị khi để trống (vd "không giới hạn"). */
export function NumField({ label, unit, hint, example, value, onChange, min = 0, max, step = 1, emptyMeans, width = 150, className }) {
    return (
        <Field label={label} className={className} hint={emptyMeans ? `${hint || ""} Để trống = ${emptyMeans}.`.trim() : hint} example={example}>
            <InputNumber
                value={value ?? null}
                min={min}
                max={max}
                step={step}
                style={{ width }}
                addonAfter={unit}
                onChange={(v) => onChange(v === null || v === undefined ? (emptyMeans ? null : min) : v)}
            />
        </Field>
    );
}

/** Thẻ nhóm cấu hình (có icon + neo mục lục) + nút "Khôi phục mặc định" (xác nhận, chưa lưu cho tới khi bấm Lưu). */
export function GroupCard({ id, icon, tone = "text-indigo-500", title, description, onReset, resetDisabled, resetHint, children }) {
    return (
        <Card
            id={id}
            size="small"
            className="shadow-sm scroll-mt-4"
            title={<span>{icon && <FontAwesomeIcon icon={icon} className={`${tone} mr-2`} />}{title}</span>}
            extra={
                <Popconfirm
                    title="Khôi phục giá trị mặc định cho nhóm này?"
                    description="Chỉ đổi trên màn hình, chưa lưu cho tới khi bạn bấm Lưu cấu hình."
                    okText="Khôi phục"
                    cancelText="Huỷ"
                    onConfirm={onReset}
                    disabled={resetDisabled}
                >
                    <Tooltip title={resetDisabled ? resetHint : undefined}>
                        <Button size="small" disabled={resetDisabled}>Khôi phục mặc định</Button>
                    </Tooltip>
                </Popconfirm>
            }
        >
            {description && <div className="text-gray-500 text-sm mb-4">{description}</div>}
            {children}
        </Card>
    );
}
